import Alpine from 'alpinejs';

Alpine.data('codeSnippetCopy', () => ({
  copied: false,

  copy(button) {
    const pre = button.closest('figure.code-example')?.querySelector('pre');
    if (!pre) return;

    const text = pre.textContent ?? '';

    navigator.clipboard.writeText(text).then(() => {
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    });
  },
}));
